export const COMPONENTS_TYPE_MAP = {
  text: 'InputField',
  email: 'InputField',
  tel: 'InputField',
  dropdown: 'Select',
  radiogroup: 'RadioGroup',
  multiple_checkbox: 'CheckboxGroup',
  textgroup: 'InputFieldGroup',
  file: 'FileUpload',
  multiple_dropdown: 'Select',
  multiple_text: 'MultipleInputField',
  checkbox: 'CheckboxRadio'
};

export const WIDGETS_WITH_OPTIONS = ['dropdown', 'radiogroup', 'multiple_checkbox', 'multiple_dropdown'];

export const API_URL = `${process.env.VUE_APP_API_URL}/api/`;

export const SESSION_COOKIE = 'pepsikoPollsSession';

export const COMPANY_POLLS = [22, 20, 21];

export const COMPANY_POLLS_SELECTION_PARAMS = ['?profile=true', '?details=true', '?category=true'];
